"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLink = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const NavLink_1 = require("components/NavLink");
//
// properties
//
const config_1 = require("assets/styles/config");
const activeClassName = 'nav-item-active';
exports.StyledLink = (0, styled_components_1.default)(NavLink_1.NavLink).attrs({ activeClassName }) `
  border-bottom: 1px solid ${config_1.colors.huron};
  color: ${config_1.colors.grayText};
  font: ${config_1.fontSizes.base} ${config_1.fontFamilies.primary};
  margin: 0 20px -1px 0;
  padding: 25px 0;

  &:hover,
  &:focus {
    color: ${config_1.colors.blurple};
  }

  &.${activeClassName} {
    border-bottom: 1px solid ${config_1.colors.blurple};
    color: ${config_1.colors.black};
    font: bold ${config_1.fontSizes.base} ${config_1.fontFamilies.primary};
  }
`;
